import { Target, Eye, HeartHandshake } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { useContent } from "../lib/content";

const ITEMS = [
    {
        icon: Target,
        title: "Missão",
        text: "Levar conveniência, economia de tempo e qualidade de vida aos moradores, com um mercado completo funcionando 24 horas dentro do condomínio.",
        cls: "bg-[#0E6B3F] text-[#F7F4EC]",
        accent: "text-[#F1C75B]",
    },
    {
        icon: Eye,
        title: "Visão",
        text: "Ser a rede de minimercados autônomos de condomínios mais amada do Brasil, presente nos bairros onde as pessoas vivem.",
        cls: "bg-[#F1C75B] text-[#1A231E]",
        accent: "text-[#F57A3A]",
    },
    {
        icon: HeartHandshake,
        title: "Valores",
        text: "Segurança em primeiro lugar, praticidade no dia a dia, proximidade com moradores e síndicos, e total transparência com o condomínio.",
        cls: "bg-[#F57A3A] text-[#F7F4EC]",
        accent: "text-[#F1C75B]",
    },
];

export default function Sobre() {
    const t = useContent().sobre;
    const textMap = [t.missao, t.visao, t.valores];
    return (
        <section id="quem-somos" className="scroll-mt-24 bg-[#F7F4EC] py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal className="max-w-2xl">
                    <SectionTag tone="green">Quem somos</SectionTag>
                    <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#1A231E]">
                        {t.title}
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-[#1A231E]/70 leading-relaxed">
                        {t.subtitle}
                    </p>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
                    {ITEMS.map((item, i) => (
                        <Reveal key={item.title} delay={i * 0.08}>
                            <div
                                className={`h-full rounded-[1.75rem] p-8 sm:p-9 ${item.cls} hover:-translate-y-1.5 transition-transform duration-300`}
                            >
                                <item.icon className={`w-10 h-10 ${item.accent}`} strokeWidth={2} />
                                <h3 className="mt-5 text-2xl font-extrabold">{item.title}</h3>
                                <p className={`mt-3 text-base leading-relaxed ${item.cls.includes("text-[#1A231E]") ? "text-[#1A231E]/75" : "text-white/85"}`}>
                                    {textMap[i] || item.text}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
